export class FetchCookieConsent {
  static readonly type = '[User] FetchCookieConsent';
}
